import { render, staticRenderFns } from "./LaudoAvaliacaoFundiarias.vue?vue&type=template&id=1a4f321a&scoped=true&lang=pug"
import script from "./LaudoAvaliacaoFundiarias.vue?vue&type=script&lang=js"
export * from "./LaudoAvaliacaoFundiarias.vue?vue&type=script&lang=js"
import style0 from "./LaudoAvaliacaoFundiarias.vue?vue&type=style&index=0&id=1a4f321a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4f321a",
  null
  
)

export default component.exports